/******************************************************************************
 * Created Date: Thursday Febuary 10th 2022                                   *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Thurs Feb 10 2022                                           *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/components/account/Users/components/Header/index.js             *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

import PropTypes from "prop-types";
import { Avatar, Typography } from "@mui/material";

const Header = ({ orgId, orgName, orgLogoUrl }) => {
  return (
    <div
      style={{
        height: 100,
        backgroundColor: "#2C2C2C",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center"
      }}
    >
      <Avatar
        style={{
          height: 70,
          width: 70,
          margin: "0 1em"
        }}
        alt={orgName}
        src={orgLogoUrl}
      />
      <Typography variant="h3">{orgName || orgId}</Typography>
    </div>
  );
};

Header.defaultProps = {
  orgId: null,
  orgName: "",
  orgLogoUrl: ""
};

Header.propTypes = {
  orgId: PropTypes.string.isRequired,
  orgName: PropTypes.string.isRequired,
  orgLogoUrl: PropTypes.string.isRequired
};

export default Header;
